// Mirrors ProjectTypeAssignment.ContractDecision in ezbuild_back.
const CONTRACT_DECISIONS = {
  NOT_ASKED: 1,
  INCLUDED: 2,
  NOT_INCLUDED: 3
} as const

type ContractDecisionKeys = keyof typeof CONTRACT_DECISIONS
type ContractDecisionValue = (typeof CONTRACT_DECISIONS)[ContractDecisionKeys]

export { CONTRACT_DECISIONS, type ContractDecisionValue }
